import React, { useContext, useState } from 'react'
import RecommendedJobCard from '../../../components/Cards/RecommendedJobCard';
import { GoOrganization } from "react-icons/go";
import { SiAwsorganizations } from "react-icons/si";
import { IoTimeSharp } from "react-icons/io5";
import { Ri24HoursLine, RiTimeZoneFill } from "react-icons/ri";
import { FaLocationDot } from "react-icons/fa6";
import { BiCategory } from "react-icons/bi";
import { FaRegCalendarAlt, FaShare, FaShoppingBag, FaWallet } from "react-icons/fa";
import { GrLocation } from 'react-icons/gr'
import { HiOutlineBriefcase } from 'react-icons/hi2'
import SuperAdminContext from '../../../hooks/SuperAdminContext';
import axiosInstance from '../../../services/api/axiosInstance';
import { TiTickOutline } from "react-icons/ti";
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { encryptData } from 'Security/Crypto/Crypto';
import { IoIosSearch } from 'react-icons/io';
import { MdClear } from "react-icons/md";
import InputGroup from '../../../components/Input/InputGroup';


const JobDetailView = () => {
    const {
        initialGlow,
        employerSkills, emplyerRecommended,
        employerSelectedCardData, employerSelectedJob,
        getJobList,
        candidatesList, candidatesListDupli,
        handleRecommendationProfileSearch, recomSelectedCandidate,
        setRecomSelectedCandidate, getJobDashboard,
        deletingCardId, setDeletingCardId,
        jobApplyFilterLoading, jobCandidateListResponse,
        employerTakeNotes, setEmployerTakeNotes,
        employerSavingNotes, setemployerSavingNotes,
        jobMakeRecommendation, setjobMakeRecommendation,
        employerClearNotes, setEmployerClearNotes
    } = useContext(SuperAdminContext);

    const recommendedPlaceholderArray = [1, 2, 3];
    const [searchFocus, setSearchFocus] = useState(false);
    const [searchIp, setSearchIp] = useState("");
    const [recomFeedback, setRecommFeedback] = useState("");
    const pageRender = useNavigate();

    const handleSetRecommendationFeedback = (e) => {
        var limitingCharacters = e.target.value.slice(0, 250);
        setRecommFeedback(limitingCharacters)
    }

    const handleDeleteRecommended = async (id) => {
        setDeletingCardId(id)
        try {
            var obj = {
                job_id: employerSelectedCardData.id,
                professional_id: id,
                role_id: 2
            }
            const res = await axiosInstance.post("/delete_recommendation", obj)
            if (res.data.error_code === 0) {
                getJobDashboard("makeRecomrecall");
            }

        } catch (err) {
            console.log(err)
        }
    }

    const handleSelectCandidate = (val) => {
        setRecomSelectedCandidate({
            city: val.city,
            country: val.country,
            first_name: val.first_name,
            job_title: val.job_title,
            last_name: val.last_name,
            professional_id: val.professional_id,
            profile_image: val.profile_image,
            state: val.state,
            applied_status: val.applied_status,
        })
        setSearchIp(`${val.first_name} ${val.last_name}`)
        setSearchFocus(false)
    }

    const handleMakeRecomBtn = async () => {
        try {
            if (recomFeedback !== "") {
                if (recomSelectedCandidate.professional_id !== 0) {
                    var obj = {
                        job_id: employerSelectedCardData.id,
                        applied_status: recomSelectedCandidate.applied_status,
                        professional_id: recomSelectedCandidate.professional_id,
                        description: recomFeedback,
                        flag: "employer",
                        employer_id: employerSelectedCardData.employer_id
                    }

                    if (employerSelectedCardData.id !== 0 && recomSelectedCandidate.professional_id !== 0) {
                        setjobMakeRecommendation(true)

                        const res = await axiosInstance.post("/make_recommendation", obj);
                        if (res.data.error_code === 0) {
                            getJobDashboard("makeRecomrecall")
                        } else {
                            setjobMakeRecommendation(false)
                        }
                    }
                } else {
                    toast.error("please select any professional")
                }
            } else {
                toast.error("please fill in all the fields")
            }
        } catch (err) {
            console.log(err)
        }
    }

    const handleupdateNotes = async (action) => {
        try {
            if (action === "send") {
                if (employerTakeNotes !== '') {
                    setemployerSavingNotes(true)
                    var obj = {
                        job_id: employerSelectedCardData.id,
                        custom_notes: employerTakeNotes
                    }

                    if (employerSelectedCardData.id !== "") {
                        const res = await axiosInstance.post("/admin_custom_notes", obj);

                        if (res.data.error_code === 0) {
                            getJobDashboard("recall")
                        } else {
                            setemployerSavingNotes(false)
                        }
                    }
                } else {
                    toast.error("please fill in all fields")
                }
            } else {
                if (employerTakeNotes !== '') {
                    setEmployerClearNotes(true)
                    var obj = {
                        job_id: employerSelectedCardData.id,
                        custom_notes: ''
                    }

                    if (employerSelectedCardData.id !== "") {
                        const res = await axiosInstance.post("/admin_custom_notes", obj);

                        if (res.data.error_code === 0) {
                            getJobDashboard("recall")
                        } else {
                            setEmployerClearNotes(false)
                        }
                    }
                } else {
                    toast.error("nothing to clear")
                }
            }

        } catch (err) {
            console.log(err)
        }
    }

    const handleApplicantRender = (job_id, employerData) => {
        let generate = false;
        const encryptedJobId = encryptData(job_id);

        if (employerData?.pricing_category === "Basic" && employerData?.payment_status === "active") generate = true
        if (encryptedJobId) pageRender(`/super_admin/jobs/job_id?id=${encryptedJobId}&responsive=false&generate=${generate}`)
    }

    const handleCopytext = () => {
        navigator.clipboard.writeText(employerSelectedCardData?.job_share_link);
        toast.success("Link copied");
    };

    return (
        <div className='col h-100 overflow-scroll'>
            {
                initialGlow || employerSelectedJob || jobApplyFilterLoading ?
                    <>
                        <div className="card h-100 border-0">
                            <div className="card-body h-100 overflow-scroll p-0 p-lg-3">
                                <div className="container-fluid">
                                    <div className="row border-bottom border-secondary border-1 py-4">
                                        <div className="col-2 text-center">
                                            <img
                                                src={""}
                                                alt="..."
                                                width={100}
                                                height={100}
                                                className="pe-none placeholder rounded-circle"
                                            />
                                        </div>

                                        <div className="col-10">
                                            <div className="row">
                                                <div className="col-lg-6 col-xxl-8">
                                                    <h1 className="employer-card-candidate-name mb-0 d-inline-block pe-3 border-end border-dark placeholder w-50 py-3 rounded-1 me-2"></h1>
                                                </div>
                                                <div className="col-12 pt-4 row">
                                                    <div className="col-4">
                                                        <p className="employer-card-candidate-role placeholder pt-3 pb-2 w-100 rounded-1"></p>
                                                    </div>
                                                </div>
                                                <div className="col-12 d-flex flex-wrap">
                                                    <div className='col-12 col-md-6 p-1'>
                                                        <button type="button" className="btn w-100 py-1 placeholder"></button>
                                                    </div>
                                                    <div className='col-12 col-md-6 p-1'>
                                                        <button type="button" className="btn w-100 py-1 placeholder"></button>
                                                    </div>
                                                    <div className='col-12 col-md-6 p-1'>
                                                        <button type="button" className="btn w-100 py-1 placeholder"></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 mt-3">
                                        <h1 className='employer-card-candidate-name placeholder rounded-2 col-4 py-2 pb-3'></h1>

                                        <div className="row w-100">
                                            {recommendedPlaceholderArray.map((v, i) => {
                                                return <div className="col-12 col-md-6 col-xl-4 py-2" key={i}>
                                                    <div className="d-flex flex-wrap border rounded-2 w-100 p-3 pe-0">
                                                        <div className="col-3 placeholder rounded-circle pe-none">
                                                            <img
                                                                src={""}
                                                                width={48}
                                                                height={48}
                                                                className="opacity-0 d-block"
                                                                alt="..."
                                                            />
                                                        </div>
                                                        <div className="col-9">
                                                            <div className="container-fluid">
                                                                <p className='mb-0 pb-1 superAdmin-recommended-card-heading placeholder rounded-2 w-100 py-3 mb-1'></p>
                                                                <p className="mb-0 superAdmin-recommended-card-sub-content mb-1">
                                                                    <span className="pe-2 placeholder rounded-2"><HiOutlineBriefcase /></span>
                                                                    <span className="placeholder rounded-2 w-50 py-2 ms-2"></span>
                                                                </p>
                                                                <p className="mb-0 superAdmin-recommended-card-sub-content">
                                                                    <span className="pe-2 placeholder rounded-2"><GrLocation /></span>
                                                                    <span className="placeholder rounded-2 w-50 py-2 ms-2"></span>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            })}
                                        </div>
                                    </div>

                                    <div className="py-4">
                                        <div>
                                            <h5 className="job-title-weight placeholder rounded col-4 py-3"></h5>
                                            <p className="job-description placeholder rounded skeleton-jobParagraph-medium col-12"></p>
                                        </div>
                                        <div className="d-flex justify-content-around mt-4">
                                            <label className="company-details-icon placeholder rounded col-2 py-2 pt-3"></label>
                                            <label className="company-details-icon placeholder rounded col-2 py-2 pt-3"></label>
                                        </div>

                                        <div className="mt-4">
                                            <h1 className="job-title-weight placeholder rounded col-4 py-3"></h1>
                                            <p className="job-description placeholder rounded col-12 skeleton-jobParagraph-medium"></p>
                                            <p className="job-description placeholder rounded col-12 skeleton-jobParagraph-medium"></p>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                    :
                    <>
                        {
                            employerSelectedCardData?.id !== 0 ?
                                <div className="card h-100 border-0">
                                    <div className="card-body h-100 overflow-scroll p-0 p-lg-3">
                                        <div className="container-fluid pb-5">
                                            <div className="row border-bottom border-secondary border-1 py-4">
                                                <div className="col-12 col-sm-3 col-xl-2 text-center">
                                                    <img
                                                        src={`${process.env.REACT_APP_SECOND_CAREERS_CDN}${employerSelectedCardData?.profile_image}`}
                                                        alt=""
                                                        width={100}
                                                        height={100}
                                                        className="rounded-circle"
                                                    />
                                                </div>

                                                <div className="col-12 col-sm-8 col-xl-8 pt-4 pt-sm-0 ">
                                                    <div className="container">
                                                        <div className="d-flex flex-wrap align-items-center h-100">
                                                            <div className={window.location.pathname === "/employer_dashboard/candidates/full_details"
                                                                ? "col-12 d-flex flex-wrap align-items-center text-center text-md-start"
                                                                : "col-12  d-flex flex-wrap align-items-center"
                                                            }>

                                                                <h1 className="employer-card-candidate-name mb-0 d-inline-block pe-3 w-100 text-center text-sm-start">
                                                                    <span className="superAdmin-full-details-border pe-sm-3">
                                                                        {employerSelectedCardData?.company_name}
                                                                    </span>

                                                                    <span className="employer-card-candidate-role mb-0 ps-3 d-none d-sm-inline-block">
                                                                        {employerSelectedCardData?.job_title}
                                                                    </span>
                                                                </h1>

                                                                <h1 className="employer-card-candidate-name mb-0 pe-3 w-100 d-block d-sm-none mt-3 text-center">
                                                                    <span className="employer-card-candidate-role mb-0 ">
                                                                        {employerSelectedCardData?.job_title}
                                                                    </span>
                                                                </h1>
                                                            </div>

                                                            {employerSelectedCardData?.company_city !== "" ?
                                                                <div className="col-12 mt-3">
                                                                    <p className={window.location.pathname === "/employer_dashboard/candidates/full_details" ?
                                                                        "col-12 employer-card-candidate-role text-break mb-0"
                                                                        :
                                                                        "col-12 employer-card-candidate-role mb-0"}>
                                                                        <strong className='pe-0'>Location :</strong>
                                                                        <span className='ps-2'>{employerSelectedCardData?.company_city}</span>
                                                                    </p>
                                                                </div>
                                                                :
                                                                null
                                                            }

                                                            {employerSelectedCardData?.company_email !== "" ?
                                                                <div className="col-12 mt-3">
                                                                    <p className={window.location.pathname === "/employer_dashboard/candidates/full_details" ?
                                                                        "col-12 employer-card-candidate-role text-break"
                                                                        :
                                                                        "col-12 employer-card-candidate-role"}>
                                                                        <strong className='pe-0'>Email id :</strong>
                                                                        <span className='ps-2'>{employerSelectedCardData?.company_email}</span>
                                                                    </p>
                                                                </div>
                                                                :
                                                                null
                                                            }

                                                            <div className="col-12 pt-1 d-flex flex-wrap">
                                                                {
                                                                    employerSelectedCardData?.job_status?.toLowerCase() === "opened" ?
                                                                        <div className='col-12 col-md-6 col-xl-4 p-1'>
                                                                            <button type="button"
                                                                                className="btn w-100 btn-transparent border btn-brand-color mb-2 mb-lg-0 candidate-right-side-btn"
                                                                                data-bs-toggle="modal"
                                                                                data-bs-target="#employerMakeRec"
                                                                                onClick={() => {
                                                                                    setSearchFocus(false)
                                                                                    setRecommFeedback("")
                                                                                    getJobList()
                                                                                    setjobMakeRecommendation(false)
                                                                                }}>
                                                                                Recommend a Profile
                                                                            </button>
                                                                        </div>
                                                                        :
                                                                        null
                                                                }

                                                                <div className='col-12 col-md-6 col-xl-4 p-1'>
                                                                    {
                                                                        employerSelectedCardData?.custom_notes === "" ?
                                                                            <button type="button"
                                                                                className='btn btn-transparent border border-brand-color candidate-right-side-btn w-100'
                                                                                data-bs-toggle="modal"
                                                                                data-bs-target="#expertTakeNotesModal"
                                                                                onClick={() => {
                                                                                    setemployerSavingNotes(false)
                                                                                    setEmployerClearNotes(false)
                                                                                }}>
                                                                                Take Notes
                                                                            </button>
                                                                            :
                                                                            <button type="button"
                                                                                className="btn btn-transparent border border-brand-color candidate-right-side-btn w-100"
                                                                                data-bs-toggle="modal"
                                                                                data-bs-target="#expertTakeNotesModal"
                                                                                onClick={() => {
                                                                                    setemployerSavingNotes(false)
                                                                                    setEmployerClearNotes(false)
                                                                                }}>
                                                                                Noted
                                                                            </button>
                                                                    }
                                                                </div>

                                                                <div className='col-12 col-md-6 col-xl-4 p-1'>
                                                                    <button type="button"
                                                                        className='btn btn-transparent border border-brand-color candidate-right-side-btn w-100'
                                                                        onClick={() => handleApplicantRender(employerSelectedCardData?.id, employerSelectedCardData)}
                                                                    >
                                                                        View Applicants
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col text-end">
                                                    <button type="button" className='btn btn-brand-color py-1' data-testid="Share" data-bs-toggle="modal" data-bs-target="#shareModal">
                                                        <FaShare />
                                                        <span className='ps-2'>Share</span>
                                                    </button>`
                                                </div>
                                            </div>

                                            <div className="col-12 mt-3">
                                                <h1 className='employer-card-candidate-name'>Recommended Profiles</h1>
                                                <div className="row w-100">
                                                    {

                                                        emplyerRecommended?.length > 0 ?
                                                            emplyerRecommended?.map((v, i) => {
                                                                return (
                                                                    <RecommendedJobCard
                                                                        heading={`${v.first_name} ${v.last_name}`}
                                                                        contentOne={v.job_title}
                                                                        contentTwo={v.city}
                                                                        image={`${process.env.REACT_APP_SECOND_CAREERS_CDN}${v.profile_image}`}
                                                                        id={v.professional_id}
                                                                        key={i}
                                                                        cardType={true}
                                                                        handleDeleteRecommended={handleDeleteRecommended}
                                                                        deletingCardId={deletingCardId}
                                                                    />
                                                                )
                                                            })
                                                            :
                                                            <RecommendedJobCard cardType={false} icon="profile" />
                                                    }
                                                </div>
                                            </div>

                                            <div className="py-4">
                                                <div>
                                                    <h5 className="job-title-weight">About Company</h5>
                                                    <p className="job-description">{employerSelectedCardData?.company_description}</p>
                                                </div>
                                                <div className="d-flex justify-content-around mt-4">
                                                    <label className="company-details-icon ">
                                                        <GoOrganization className="me-2 text-success" />
                                                        {employerSelectedCardData?.employer_type}
                                                    </label>
                                                    <label className="company-details-icon">
                                                        <SiAwsorganizations className="me-2 text-warning" />
                                                        {employerSelectedCardData?.sector}
                                                    </label>
                                                </div>

                                                <div className="mt-4">
                                                    <h5 className="job-title-weight">Job Summary</h5>

                                                    <div className="job-description professional-quill" dangerouslySetInnerHTML={{ __html: employerSelectedCardData?.job_desc }}></div>
                                                </div>

                                                <div className="row justify-content-around mt-4 dashboard-job-post-icons">
                                                    <h5 className="job-title-weight">Additional Job details</h5>
                                                    <div className="col-6 p-2 ps-2 ps-md-5">
                                                        <label className="company-details-icon">
                                                            <FaLocationDot className="me-2 text-success" />
                                                            {`${employerSelectedCardData?.workplace_type} - ${employerSelectedCardData?.job_city}`}
                                                        </label>
                                                    </div>
                                                    <div className="col-6 p-2 ps-2 ps-md-5">
                                                        <label className="company-details-icon">
                                                            <Ri24HoursLine className="me-2 text-primary" />
                                                            {employerSelectedCardData?.time_commitment}
                                                        </label>
                                                    </div>
                                                    <div className="col-6 p-2 ps-2 ps-md-5">
                                                        <label className="company-details-icon">
                                                            <RiTimeZoneFill className="me-2 text-primary" />
                                                            {employerSelectedCardData?.timezone}
                                                        </label>
                                                    </div>
                                                    <div className="col-6 p-2 ps-2 ps-md-5">
                                                        <label className="company-details-icon">
                                                            <IoTimeSharp className="me-2 text-warning" />
                                                            {employerSelectedCardData?.job_type}
                                                        </label>
                                                    </div>
                                                    <div className="col-6 p-2 ps-2 ps-md-5">
                                                        <label className="company-details-icon">
                                                            <FaShoppingBag className="me-2 text-primary" />
                                                            {employerSelectedCardData?.work_schedule}
                                                        </label>
                                                    </div>
                                                    <div className="col-6 p-2 ps-2 ps-md-5">
                                                        <label className="company-details-icon">
                                                            <FaWallet className="me-2 text-success" />
                                                            {employerSelectedCardData?.is_paid === "Y" ? "Paid" : "Volunteer"}
                                                        </label>
                                                    </div>
                                                    <div className="col-6 p-2 ps-2 ps-md-5">
                                                        <label className="company-details-icon">
                                                            <BiCategory className="me-2 text-warning" />
                                                            {employerSelectedCardData?.specialisation}
                                                        </label>
                                                    </div>
                                                    <div className="col-6 p-2 ps-2 ps-md-5">
                                                        {employerSelectedCardData?.duration === "0-Select" || employerSelectedCardData?.duration === "-Years" || employerSelectedCardData?.duration === "0-Years" || employerSelectedCardData?.duration === "-Months" || employerSelectedCardData?.duration === "0-Months" || employerSelectedCardData?.duration === "-Weeks" || employerSelectedCardData?.duration === "0-Weeks"
                                                            ? null
                                                            :
                                                            <label className="company-details-icon">
                                                                <FaRegCalendarAlt className="me-2 text-warning" />
                                                                {employerSelectedCardData?.duration}
                                                            </label>

                                                        }
                                                    </div>
                                                </div>

                                                {
                                                    employerSkills?.length > 0 ?
                                                        <div className="py-4">
                                                            <h5 className="job-title-weight">Skills / Competencies</h5>
                                                            <ul className="ms-5 dashboard-skills-ul">
                                                                {employerSkills?.map((v, i) => {
                                                                    return v !== '' ? <li key={i}>{v}</li> : null;
                                                                })}
                                                            </ul>
                                                        </div>
                                                        :
                                                        null
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="h-100 w-100 row align-items-center">
                                    <p className='text-center'>No Data Found</p>
                                </div>
                        }
                    </>
            }

            {/* take notes modal box  */}
            <div
                className="modal fade"
                id="expertTakeNotesModal"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                tabIndex="-1"
                aria-labelledby="staticBackdropLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered modal-md vh-50">
                    <div className="modal-content ">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="staticBackdropLabel">
                                Take notes
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                id="closeEmpTakeNotes"
                            ></button>
                        </div>
                        <div className="modal-body">
                            <div className="container">
                                <div className="row">
                                    <textarea
                                        className="p-3 rounded-3 form-control outline-none"
                                        minLength={25}
                                        maxLength={10000}
                                        rows={5}
                                        placeholder="Enter some text here"
                                        value={employerTakeNotes}
                                        onChange={(e) => setEmployerTakeNotes(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <div className="container">
                                <div className="row align-items-center">
                                    <div className="col-lg-6">
                                        {
                                            employerClearNotes ?
                                                <button className="btn btn-transparent border border-brand-color w-100 my-2 px-3 candidate-right-side-btn" type="button">
                                                    <span span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                    <span className="ps-2 d-none d-lg-inline">Clearing...</span>
                                                </button>
                                                :
                                                employerSavingNotes ?
                                                    <button
                                                        type="button"
                                                        className="btn btn-transparent border border-brand-color w-100 my-2 px-3 candidate-right-side-btn pe-none"
                                                    >
                                                        Clear
                                                    </button>
                                                    :
                                                    <button
                                                        type="button"
                                                        className="btn btn-transparent border border-brand-color w-100 my-2 px-3 candidate-right-side-btn"
                                                        onClick={() => handleupdateNotes("clear")}
                                                    >
                                                        Clear
                                                    </button>
                                        }
                                    </div>

                                    <div className="col-lg-6">
                                        {
                                            employerSavingNotes ?
                                                <button className="btn btn-brand-color pe-none w-100" type="button">
                                                    <span span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                    <span className="ps-2 d-none d-lg-inline">Saving...</span>
                                                </button>
                                                :
                                                employerClearNotes ?
                                                    <button
                                                        type="button"
                                                        className="btn btn-brand-color w-100 my-2 px-5 pe-none"
                                                    >
                                                        Save
                                                    </button>
                                                    :
                                                    <button
                                                        type="button"
                                                        className="btn btn-brand-color w-100 my-2 px-5"
                                                        onClick={() => handleupdateNotes("send")}
                                                    >
                                                        Save
                                                    </button>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* make recommendation */}
            <div
                className="modal fade"
                id="employerMakeRec"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                tabIndex="-1"
                aria-labelledby="staticBackdropLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered modal-lg vh-50">
                    <div className="modal-content p-2" style={{ height: '40rem' }}>
                        <div className="modal-header border-bottom-0">
                            <h1 className="modal-title fs-5" id="staticBackdropLabel">
                                Recommendations to professionals
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                id="closeEmpMakeRecBtn"
                                onClick={() => {
                                    setSearchFocus(false)
                                    setSearchIp("")
                                    setRecomSelectedCandidate({
                                        city: "",
                                        country: "",
                                        first_name: "",
                                        job_title: "",
                                        last_name: "",
                                        professional_id: 0,
                                        profile_image: "",
                                        state: ""
                                    })
                                    setRecommFeedback("")
                                }}
                            ></button>
                        </div>
                        <div className="modal-body border-bottom-0">
                            <div className="container">
                                {
                                    jobCandidateListResponse ?
                                        <>
                                            <div className="w-100 placeholder py-3 rounded-2"></div>
                                            <div className="w-100 mt-3 sprAdminEmployerPlaceholderHeight placeholder py-3 rounded-2"></div>
                                        </>
                                        :
                                        <div className="row">
                                            <label htmlFor="ipName" className="mb-1">Name</label>
                                            <div className="mb-3 col-12 superAdmin-searchCandidate">
                                                <div className="d-flex position-relative">
                                                    <InputGroup
                                                        className="home-search-icon fs-5"
                                                        reIcons={<IoIosSearch />}
                                                    />

                                                    <input
                                                        type="text"
                                                        placeholder="Enter Professional name"
                                                        value={searchIp}
                                                        onFocus={() => setSearchFocus(true)}
                                                        onChange={(e) => setSearchIp(e.target.value)}
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter") {
                                                                setSearchFocus(true)
                                                                handleRecommendationProfileSearch({ search_text: searchIp, job_id: employerSelectedCardData?.id })
                                                            }
                                                        }}
                                                        className="form-control"
                                                        id="ipName"
                                                        style={{ padding: ".67rem 2.5rem" }}
                                                    />

                                                    {
                                                        searchIp ?
                                                            <div className='searchButtonClick-superAdmin ' title='Search' onClick={() => {
                                                                setSearchFocus(true)
                                                                handleRecommendationProfileSearch({ search_text: searchIp, job_id: employerSelectedCardData?.id })
                                                            }}>
                                                                <IoIosSearch />
                                                            </div>
                                                            :
                                                            null
                                                    }

                                                    <div className='clearButtonClick-superAdmin' title='Clear' onClick={() => {
                                                        getJobList()
                                                        setSearchIp("")
                                                    }}>
                                                        <MdClear />
                                                    </div>
                                                </div>
                                                {
                                                    searchFocus ?
                                                        <div className="superAdmin-searchCandidate-list p-3 card shadow">
                                                            <div className="col text-end">
                                                                <button type="button" className='btn-close' onClick={() => setSearchFocus(false)}></button>
                                                            </div>
                                                            <div className="card-body row">
                                                                {
                                                                    candidatesListDupli.map((v, i) => {
                                                                        return (
                                                                            <div className="col-12 col-lg-6 d-inline-flex align-items-center p-3">
                                                                                <div className="card w-100 h-100 cursorPointer" onClick={() => { handleSelectCandidate(v) }}>
                                                                                    <div className="card-body">
                                                                                        <div className="w-100 row">
                                                                                            <div className="col-3">
                                                                                                <img src={`${process.env.REACT_APP_SECOND_CAREERS_CDN}${v.profile_image}`} alt="..." width={52} height={52} className='rounded-circle pe-none' />
                                                                                            </div>
                                                                                            <div className="col-9 position-relative">
                                                                                                <p className="mb-1">{v.first_name} {v.last_name}</p>
                                                                                                <p>{v.job_title}</p>

                                                                                                {
                                                                                                    recomSelectedCandidate.professional_id === v.professional_id && recomSelectedCandidate.job_title === v.job_title ?
                                                                                                        <div className="sprAdmin-employer-tick-icon">
                                                                                                            <TiTickOutline className='tickIcon' />
                                                                                                        </div>
                                                                                                        :
                                                                                                        null
                                                                                                }

                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    })
                                                                }
                                                            </div>
                                                        </div>
                                                        :
                                                        null
                                                }
                                            </div>


                                            <div className="mb-3 col-12">
                                                <p className='mb-0 pb-1'>Why do you think this job would be a good fit for this professional?</p>
                                                <textarea
                                                    className="p-3 rounded-3 mb-3 form-control outline-none"
                                                    rows={5}
                                                    placeholder="Enter your text here"
                                                    value={recomFeedback}
                                                    onChange={handleSetRecommendationFeedback}
                                                />
                                            </div>

                                        </div>

                                }
                            </div>
                        </div>

                        <div className="modal-footer border-top-0">
                            <div className="container">
                                <div className="row float-end">
                                    <div className="col-lg-12 ">
                                        {
                                            jobCandidateListResponse ?
                                                <button type="button" className="btn my-2 placeholder py-2 px-5"></button>
                                                :
                                                candidatesList.length > 0 ?
                                                    jobMakeRecommendation ?
                                                        <button className="btn btn-brand-color pe-none" type="button">
                                                            <span span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                            <span className="ps-2 d-none d-lg-inline">Recommending...</span>
                                                        </button>
                                                        :
                                                        <button
                                                            type="button"
                                                            className="btn btn-brand-color my-2 px-4"
                                                            onClick={handleMakeRecomBtn}
                                                        >
                                                            Make Recommendation
                                                        </button>
                                                    :
                                                    <button
                                                        type="button"
                                                        className="btn btn-brand-color my-2 px-4"
                                                        data-bs-dismiss="modal"
                                                    >
                                                        Close
                                                    </button>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </div >

            {/* share modal  */}
            <div
                className="modal fade"
                id="shareModal"
                tabIndex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="exampleModalLabel">
                                Share
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body pt-0 ">
                            <div className="mb-5 position-relative">
                                <label htmlFor="message-text" className="col-form-label mb-2">
                                    Copy link
                                </label>
                                <input
                                    className="form-control  mx-auto mt-0 linkFieldSize"
                                    id="message-text"
                                    value={employerSelectedCardData?.job_share_link}
                                    readOnly
                                />
                                <button
                                    type="button"
                                    className="btn btn-brand-color button-position"
                                    onClick={handleCopytext}
                                >
                                    Copy
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default JobDetailView